import { getCountryInformations } from "./location"
import { gifts, trophies, websiteParameters } from "./types"
import { api_getValueOrErrorMessage, api_postValueOrErrorMessage } from "./util"

export const api_getPlatformInformations = async () => {
    return await api_getValueOrErrorMessage<websiteParameters>("website/parameters")
}

export const getPlatformTrophies = async () => {
    return await api_getValueOrErrorMessage<trophies>("trophies");
}

export const getPlatformGifts = async () => {
    return await api_getValueOrErrorMessage<gifts>("gifts");
}

export const getPlatformCountriesPerContinent = async () => {
    if(localStorage.getItem("locationContinent")) return JSON.parse(localStorage.getItem("locationContinent") as string);
    const continents = ["africa", "america", "asia", "europe", "oceania", "antarctic"];
    // The informations call depends on each continent's country list, but the
    // continents themselves are independent — fetch them concurrently.
    const infos = await Promise.all(continents.map(async continent => {
        let countries = await api_postValueOrErrorMessage<{countries: number[]}>("location/countries", {continent});
        return getCountryInformations(countries.countries);
    }));
    let returnValues:any = {};
    continents.forEach((continent, index) => returnValues[continent] = infos[index]);
    localStorage.setItem("locationContinent", JSON.stringify(returnValues));
    return returnValues;
}